import React from 'react';
import styles from './divider.module.scss';

export const ThinDivider = ({ className = '' }) => (
    <div className={`${styles.thinDivider} ${className}`} />
);

export const ThickDivider = ({ className = '' }) => (
    <div className={`${styles.thickDivider} ${className}`} />
);
